import { html } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { ComponentLoaderMixin } from '@trp-dms-digital-shared/ds-ui-library-components/src/lib/component-loader/component-loader.js';
import { mixin } from '@trp-dms-digital-shared/ds-ui-library-common';
import { BeaconTile } from '@trp-beacon-ui-kit/foundation/components/index.js';
import { Constants } from './base.constants';

@customElement(Constants.POP_BASE_TILE_TAG_NAME)
export class PopBaseTileComponent extends mixin(
  BeaconTile,
  ComponentLoaderMixin,
) {
  @state()
  initialized = false;

  protected initialize() {
    this.initialized = true;
  }

  protected render() {
    return !this.initialized ? html`` : super.renderTile();
  }
}

if (customElements.get(Constants.POP_BASE_TILE_TAG_NAME) === undefined) {
  customElements.define(Constants.POP_BASE_TILE_TAG_NAME, PopBaseTileComponent);
}
